import { ImgHTMLAttributes, useEffect, useState } from "react";

/**
 * Grafika „brak wyników" (search.gif, 1,8 MB) ładowana leniwie.
 * GIF zostaje jako zasób, ale jego URL nie jest już wciągany statycznie do chunku —
 * plik pobiera się dopiero gdy pusty stan faktycznie się wyrenderuje (dynamiczny import),
 * a `loading="lazy"` dodatkowo odracza pobranie do momentu zbliżenia do viewportu.
 */
const SearchEmptyImg = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    let alive = true;
    import("assets/icons/search.gif").then((m) => {
      if (alive) setSrc(m.default);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!src) return null;
  return <img src={src} loading="lazy" alt="" {...props} />;
};

export default SearchEmptyImg;
